import { render, staticRenderFns } from "./selectBot.vue?vue&type=template&id=3dda0f80&scoped=true"
import script from "./selectBot.vue?vue&type=script&lang=js"
export * from "./selectBot.vue?vue&type=script&lang=js"
import style0 from "./selectBot.vue?vue&type=style&index=0&id=3dda0f80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda0f80",
  null
  
)

export default component.exports